<div class="m-menu"
     :class="[ 'm--is-skin-' + skin,
               { 'm--is-open': propOpen,
                 'm--is-disabled': propDisabled }]">
    <div v-if="$slots.trigger"
         class="m-menu__trigger"
         :class="{'m--is-disabled': propDisabled }"
         :tabindex="propDisabled ? '-1' : '0'"
         :aria-controls="idAriaControls"
         :aria-expanded="propOpen"
         @click="toggleMenu"
         @keypress.enter="toggleMenu"
         aria-haspopup="true"
         ref="buttonMenu">
        <m-plus class="m-menu__trigger__plus"
                :large="true"
                :open="propOpen"
                :title-open="titleMenuOpen"
                :title-close="titleMenuClose"
                skin="current-color"></m-plus>
        <slot name="trigger"></slot>
    </div>
    <m-accordion-transition ref="transition"
                            @before-enter="beforeEnter"
                            @enter="enter"
                            @after-enter="afterEnter"
                            @enter-cancelled="enterCancelled"
                            @before-leave="beforeLeave"
                            @leave="leave"
                            @after-leave="afterLeave"
                            @leave-cancelled="leaveCancelled"
                            :disabled="!animReady || propDisabled">
        <ul v-show="propOpen"
            :id="idAriaControls"
            class="m-menu__body"
            :aria-hidden="!propOpen"
            role="menu"
            ref="menu">
            <slot></slot>
        </ul>
    </m-accordion-transition>
</div>
